<app-breadcrumb [title]="'Language' | transloco" faIcon="fa-language"></app-breadcrumb>
<app-card [titleHeaderText]="'Select Language' | transloco">
  <div class="language-selector-wrapper" body>
    <app-language-selector></app-language-selector>
  </div>
</app-card>
